module.exports = __webpack_public_path__ + "static/media/2016-normalized.7c537066.csv";